/**
 *   Packages
 * ------------------------------------------------------ */
import { dtos } from '@shd/jslib/models';
import { AuthCredential, AuthProvider } from 'firebase/auth';

import type { JSX } from "react";

export type AuthProviderIds =
  | 'apple.com'
  | 'google.com'
  | 'facebook.com'
  | 'phone';

/**
 *   Enums
 * ------------------------------------------------------ */
export enum AuthProviders {
  APPLE = 'apple.com',
  GOOGLE = 'google.com',
  FACEBOOK = 'facebook.com',
  PHONE = 'phone',
}

/**
 *   Interfaces
 * ------------------------------------------------------ */
export interface AuthProps {
  errorHandler: (error: {
    message: string;
    urlText?: string;
    url?: string;
  }) => void;
  linkAccountHandler?: (credential: AuthCredential | null) => void;
  onSuccess?: (data: dtos.UserPostResponse) => void;
  postUrl: string;
  claimPlayer?: string;
  claimPlayerKey?: string;
  claimPhoneNumber?: string;
  toggleLoading: (loading: boolean) => void;
  provider: AuthProvider;
}

export interface AuthProviderInfo {
  id: string;
  icon: JSX.Element | null;
  name: string;
}
